<div data-automation="phone-model-protocol-form">
  <ziro-select [fieldId]="'model'"></ziro-select>
  <ziro-select [fieldId]="'protocol'" [hidden]="!formData.model"></ziro-select>
</div>
